<template>
  <a-row :gutter="24">
    <!-- ============ 区块1：收款模式设置（页顶卡片，总部资金策略 spec 0.6） ============ -->
    <a-col :md="24">
      <a-card :bordered="false">
        <div class="section-title">收款模式设置</div>
        <!-- 合规提示（常驻黄色警示，spec 0.6） -->
        <a-alert
          type="warning"
          show-icon
          message="合规提示"
          description="代收模式建议仅用于直营店（同一法人内部资金调拨）；加盟店（独立法人）使用代收存在二清监管风险，请谨慎选择"
          style="margin-bottom: 16px" />
        <a-form layout="inline">
          <a-row :gutter="24">
            <a-col :md="7" :sm="24">
              <a-form-item label="所属门店">
                <a-select v-model="fundStoreId" placeholder="请选择门店" style="width: 220px" @change="onFundStoreChange">
                  <a-select-option v-for="s in storeList" :key="s.id" :value="s.id">{{ s.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :md="17" :sm="24">
              <a-form-item label="允许门店收款">
                <a-switch
                  checked-children="启用"
                  un-checked-children="关闭"
                  :disabled="isFundStoreMain"
                  v-model="fundAllowPaySwitch" />
                <span class="fund-switch-tip">（开启：门店可自己进件直收；关闭：进件由总店统一管理、货款由总店代收）</span>
                <a-button type="primary" :loading="fundSaving" style="margin-left: 12px" @click="handleSaveFund">保存</a-button>
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <div class="field-tip">门店直收前置条件：门店已进件特约商户，未进件无法开启直收</div>
      </a-card>
    </a-col>
    <!-- ============ 区块2：对账计提 | 提现审批 ============ -->
    <a-col :md="24" style="margin-top: 12px">
      <a-card :bordered="false">
        <a-tabs v-model="activeTab" @change="onTabChange">
          <!-- ======== 对账计提（服务费率 + 预览计提 + 结算历史，仅对账参考不再直接结算） ======== -->
          <a-tab-pane tab="对账计提" key="settle">
            <!-- 服务费率设置（自 StoreInfo Tab4 迁入，仅总店 is_main='1' 显示） -->
            <template v-if="isFundStoreMain">
              <div class="section-title">服务费率设置</div>
              <a-form class="setting-form">
                <a-form-item label="平台抽佣模式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-radio-group v-model="commissionForm.rule">
                    <a-radio value="2">自定义抽佣设置</a-radio>
                  </a-radio-group>
                  <div class="field-tip">温馨提示：此抽佣模式建议在单商户下使用</div>
                </a-form-item>
                <a-form-item v-if="commissionForm.rule === '2'" label="佣金计算方式" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-radio-group v-model="commissionForm.type">
                    <a-radio value="1">订单百分比抽成</a-radio>
                    <a-radio value="2">按固定金额</a-radio>
                  </a-radio-group>
                </a-form-item>
              </a-form>
              <!-- 百分比模式：7 组三段式（平台抽佣% / 商家获得%只读自动 / 最低抽佣元） -->
              <a-form v-if="commissionForm.rule === '2' && commissionForm.type === '1'" class="setting-form">
                <a-form-item v-for="item in commissionItems" :key="item.key" :label="item.label + '抽佣比例'" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-input
                    v-model="commissionForm[item.key + 'PlatformProportion']"
                    addonBefore="平台抽佣"
                    addonAfter="%"
                    style="width: 220px" />
                  <span class="prop-sep"> / </span>
                  <a-input
                    :value="getStoreProportion(item.key)"
                    addonBefore="商家获得"
                    addonAfter="%"
                    disabled
                    style="width: 220px" />
                  <span class="prop-sep"> / </span>
                  <a-input
                    v-model="commissionForm[item.key + 'DownMoney']"
                    addonBefore="最低抽佣"
                    addonAfter="元"
                    style="width: 220px" />
                </a-form-item>
              </a-form>
              <!-- 固定金额模式：7 个抽成金额 -->
              <a-form v-if="commissionForm.rule === '2' && commissionForm.type === '2'" class="setting-form">
                <a-form-item v-for="item in commissionItems" :key="item.key" :label="item.label + '抽成金额'" :labelCol="formLabelCol" :wrapperCol="formWrapperCol">
                  <a-input v-model="commissionForm[item.key + 'FixedMoney']" addonAfter="元" style="width: 220px" />
                </a-form-item>
              </a-form>
              <div class="form-footer">
                <a-button type="primary" :loading="commissionSaving" @click="handleSaveCommission">保存</a-button>
              </div>
              <a-divider style="margin: 8px 0 16px" />
            </template>
            <!-- 周期计提预览（对账参考，资金兑现走门店提现申请-审批流程） -->
            <div class="section-title">周期计提</div>
            <div class="field-tip settle-tip">计提明细为对账参考，资金兑现请走门店提现申请-审批流程</div>
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-form-item label="结算月份">
                  <a-month-picker v-model="settleMonth" format="YYYY-MM" :allow-clear="false" />
                </a-form-item>
                <a-button type="primary" icon="search" style="margin-left: 8px" :loading="previewLoading" @click="handlePreview">预览计提</a-button>
              </a-form>
            </div>
            <a-table
              size="middle"
              bordered
              rowKey="storeId"
              :columns="previewColumns"
              :dataSource="previewList"
              :loading="previewLoading"
              :pagination="false">
              <template slot="modeSlot" slot-scope="text, record">
                <a-tag v-if="String(record.receiveMode) === '2'" color="green">直收</a-tag>
                <a-tag v-else color="blue">代收</a-tag>
              </template>
            </a-table>
            <a-divider style="margin: 16px 0" />
            <!-- 结算历史（SR/ZC/FK/SK 四类单据号可复制） -->
            <div class="section-title">结算历史</div>
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-form-item label="结算月份">
                  <a-month-picker v-model="historyMonth" format="YYYY-MM" :allow-clear="false" />
                </a-form-item>
                <a-button type="primary" icon="search" style="margin-left: 8px" :loading="historyLoading" @click="loadHistory">查询</a-button>
              </a-form>
            </div>
            <a-table
              size="middle"
              bordered
              :rowKey="r => r.storeId + '-' + r.cycleStart"
              :columns="historyColumns"
              :dataSource="historyList"
              :loading="historyLoading"
              :pagination="false">
              <template slot="srSlot" slot-scope="text">
                <a v-if="text" class="bill-no" @click="copyText(text)">{{ text }}</a>
                <span v-else>-</span>
              </template>
              <template slot="zcSlot" slot-scope="text">
                <a v-if="text" class="bill-no" @click="copyText(text)">{{ text }}</a>
                <span v-else>-</span>
              </template>
              <template slot="fkSlot" slot-scope="text">
                <a v-if="text" class="bill-no" @click="copyText(text)">{{ text }}</a>
                <span v-else>-</span>
              </template>
              <template slot="skSlot" slot-scope="text">
                <a v-if="text" class="bill-no" @click="copyText(text)">{{ text }}</a>
                <span v-else>-</span>
              </template>
            </a-table>
          </a-tab-pane>
          <!-- ======== 提现审批（门店提现申请：通过/驳回 + 全部记录/标记已支付） ======== -->
          <a-tab-pane tab="提现审批" key="withdraw">
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-form-item label="状态">
                  <a-select v-model="withdrawQuery.status" style="width: 130px">
                    <a-select-option value="1">待审批</a-select-option>
                    <a-select-option value="2">已通过</a-select-option>
                    <a-select-option value="3">已驳回</a-select-option>
                    <a-select-option value="4">已支付</a-select-option>
                    <a-select-option value="">全部</a-select-option>
                  </a-select>
                </a-form-item>
                <a-button type="primary" icon="search" style="margin-left: 8px" @click="onWithdrawSearch">查询</a-button>
              </a-form>
            </div>
            <a-table
              size="middle"
              bordered
              rowKey="id"
              :columns="withdrawColumns"
              :dataSource="withdrawList"
              :loading="withdrawLoading"
              :pagination="withdrawPagination"
              @change="onWithdrawPageChange">
              <template slot="amountSlot" slot-scope="text">
                <span class="amount-red">¥{{ fmtMoney(text) }}</span>
              </template>
              <template slot="withdrawStatus" slot-scope="text">
                <a-tag :color="(withdrawStatusMap[text] || {}).color">{{ (withdrawStatusMap[text] || {}).text || text }}</a-tag>
              </template>
              <span slot="withdrawAction" slot-scope="text, record">
                <template v-if="record.status === '1'">
                  <a @click="handleAuditPass(record)">通过</a>
                  <a-divider type="vertical" />
                  <a @click="handleAuditReject(record)">驳回</a>
                </template>
                <a v-else-if="record.status === '2'" @click="handleMarkPaid(record)">标记已支付</a>
                <span v-else>-</span>
              </span>
            </a-table>
          </a-tab-pane>
        </a-tabs>
      </a-card>
    </a-col>
    <!-- 驳回原因弹窗（必填） -->
    <a-modal
      title="驳回原因"
      :visible="rejectVisible"
      :confirmLoading="auditLoading"
      @ok="handleRejectSubmit"
      @cancel="rejectVisible = false">
      <a-textarea v-model="rejectReason" :rows="3" :maxLength="200" placeholder="请填写驳回原因（必填）" />
    </a-modal>
  </a-row>
</template>
<script>
import moment from 'moment'
import { getAction, postAction, putAction } from '@/api/manage'

/**
 * 连锁结算页（允许门店收款 + 对账计提 + 提现审批）
 * API 契约：
 *   GET  /api/plugin/dining/stores（chainList，行含 allowPay）
 *   PUT  /api/plugin/dining/stores/{id} body {allowPay:'1'|'0'} → 允许门店收款（门店级开关，仅总店）
 *   GET/PUT /api/plugin/dining/store-setting/commission?storeId=总店id  服务费率（自 StoreInfo Tab4 迁入，仅总店可配）
 *   GET  /api/plugin/dining/settlement/preview?cycleStart&cycleEnd → 计提五行（对账参考，不再触发确认结算）
 *   GET  /api/plugin/dining/settlement/history?month=yyyy-MM   → 结算历史（历史"确认结算"生成的四单据）
 *   GET  /api/plugin/dining/withdraw/list?page&pageSize&status&storeId → {rows,total}（status：1待审批 2已通过 3已驳回 4已支付）
 *   POST /api/plugin/dining/withdraw/{id}/audit body {pass:true|false, rejectReason}
 *   POST /api/plugin/dining/withdraw/{id}/mark-paid
 * 门店下拉：GET /api/plugin/dining/stores（pageSize=100 取全量，返回 {rows,total}，行含 isMain/allowPay）
 */
const STORE_PREFIX = '/api/plugin/dining/stores'
const SETTING_PREFIX = '/api/plugin/dining/store-setting'
const SETTLE_PREFIX = '/api/plugin/dining/settlement'
const WITHDRAW_PREFIX = '/api/plugin/dining/withdraw'

// 服务费率 7 类（key 照云贝 serviceCharge：goods/deliver/box/cashier/fast/inStore/store）
const COMMISSION_ITEMS = [
  { key: 'goods', label: '商品' },
  { key: 'deliver', label: '配送费' },
  { key: 'box', label: '包装费' },
  { key: 'cashier', label: '当面付' },
  { key: 'fast', label: '快餐' },
  { key: 'inStore', label: '店内' },
  { key: 'store', label: '储值' }
]

// 服务费率默认值（rule 2=自定义抽佣设置，type 1=订单百分比抽成）
const COMMISSION_DEFAULTS = (() => {
  const defaults = { rule: '2', type: '1' }
  COMMISSION_ITEMS.forEach(item => {
    defaults[item.key + 'PlatformProportion'] = 0
    defaults[item.key + 'StoreProportion'] = 100
    defaults[item.key + 'DownMoney'] = 0
    defaults[item.key + 'FixedMoney'] = 0
  })
  return defaults
})()

// 提现单状态：1待审批(橙) 2已通过(蓝) 3已驳回(红) 4已支付(绿)
const WITHDRAW_STATUS = {
  '1': { text: '待审批', color: 'orange' },
  '2': { text: '已通过', color: 'blue' },
  '3': { text: '已驳回', color: 'red' },
  '4': { text: '已支付', color: 'green' }
}

// 金额格式化：toFixed(2) + 千分位
function fmtMoney(val) {
  const n = Number(val)
  if (isNaN(n)) {
    return '0.00'
  }
  return n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

// 收款账户快照（银行卡：开户名 尾号；支付宝：姓名 账号）
function fmtAccountFull(acc) {
  if (!acc || !acc.accountType) {
    return '-'
  }
  if (acc.accountType === 'alipay') {
    return '支付宝：' + (acc.accountName || '-') + ' ' + (acc.alipayAccount || '-')
  }
  const tail = acc.bankNo ? String(acc.bankNo).slice(-4) : ''
  return '银行卡：' + (acc.accountName || '-') + (tail ? ' 尾号 ' + tail : '')
}

export default {
  name: 'DiningSettlementList',
  data() {
    return {
      formLabelCol: { span: 5 },
      formWrapperCol: { span: 18, offset: 1 },
      // ===== 区块1：允许门店收款（门店级开关，decentralize-store-pay A） =====
      storeList: [],
      fundStoreId: null,
      fundAllowPaySwitch: false,
      fundSaving: false,
      // ===== 服务费率设置（自 StoreInfo Tab4 迁入，仅总店） =====
      commissionForm: Object.assign({}, COMMISSION_DEFAULTS),
      commissionSaving: false,
      // ===== 对账计提 =====
      activeTab: 'settle',
      settleMonth: moment(),
      previewLoading: false,
      previewList: [],
      previewColumns: [
        { title: '门店名称', dataIndex: 'storeName', align: 'left' },
        { title: '收款模式', dataIndex: 'receiveMode', width: 100, align: 'center', scopedSlots: { customRender: 'modeSlot' } },
        { title: '总收入', dataIndex: 'income', width: 120, align: 'right', customRender: t => fmtMoney(t) },
        { title: '退款冲减', dataIndex: 'refundAmount', width: 120, align: 'right', customRender: t => fmtMoney(t) },
        { title: '货款', dataIndex: 'goodsCost', width: 120, align: 'right', customRender: t => fmtMoney(t) },
        { title: '抽佣', dataIndex: 'commission', width: 120, align: 'right', customRender: t => fmtMoney(t) },
        { title: '门店应得', dataIndex: 'payable', width: 120, align: 'right', customRender: t => fmtMoney(t) }
      ],
      // ===== 结算历史 =====
      historyMonth: moment(),
      historyLoading: false,
      historyList: [],
      historyColumns: [
        { title: '门店名称', dataIndex: 'storeName', align: 'left' },
        { title: '结算周期', dataIndex: 'cycleStart', width: 210, align: 'center', customRender: (t, r) => (r.cycleStart || '-') + ' ~ ' + (r.cycleEnd || '-') },
        { title: '抽佣', dataIndex: 'commission', width: 110, align: 'right', customRender: t => fmtMoney(t) },
        { title: '门店应得', dataIndex: 'payable', width: 110, align: 'right', customRender: t => fmtMoney(t) },
        { title: 'SR单据号', dataIndex: 'srBillNo', width: 150, align: 'center', scopedSlots: { customRender: 'srSlot' } },
        { title: 'ZC单据号', dataIndex: 'zcBillNo', width: 150, align: 'center', scopedSlots: { customRender: 'zcSlot' } },
        { title: 'FK单据号', dataIndex: 'fkBillNo', width: 150, align: 'center', scopedSlots: { customRender: 'fkSlot' } },
        { title: 'SK单据号', dataIndex: 'skBillNo', width: 150, align: 'center', scopedSlots: { customRender: 'skSlot' } },
        { title: '结算时间', dataIndex: 'settledAt', width: 160, align: 'center', customRender: t => t || '-' }
      ],
      // ===== 提现审批 =====
      withdrawQuery: { status: '1' },
      withdrawList: [],
      withdrawLoading: false,
      withdrawLoaded: false,
      withdrawPagination: { current: 1, pageSize: 10, total: 0 },
      withdrawColumns: [
        { title: '门店名称', dataIndex: 'storeName', align: 'left' },
        { title: '申请金额（元）', dataIndex: 'applyAmount', width: 130, align: 'right', scopedSlots: { customRender: 'amountSlot' } },
        { title: '收款账户', dataIndex: 'account', width: 230, customRender: t => fmtAccountFull(t) },
        { title: '申请时间', dataIndex: 'applyTime', width: 160, align: 'center', customRender: t => t || '-' },
        { title: '状态', dataIndex: 'status', width: 90, align: 'center', scopedSlots: { customRender: 'withdrawStatus' } },
        { title: '驳回原因', dataIndex: 'rejectReason', customRender: t => t || '-' },
        { title: '付款单号', dataIndex: 'billNo', width: 140, align: 'center', customRender: t => t || '-' },
        { title: '操作', dataIndex: 'action', width: 150, align: 'center', scopedSlots: { customRender: 'withdrawAction' } }
      ],
      rejectVisible: false,
      rejectReason: '',
      rejectRecord: null,
      auditLoading: false
    }
  },
  computed: {
    // 服务费率 7 类
    commissionItems() {
      return COMMISSION_ITEMS
    },
    // 提现状态映射（模板用）
    withdrawStatusMap() {
      return WITHDRAW_STATUS
    },
    // 当前选中门店是否总店（服务费率仅总店 is_main='1' 可配）
    isFundStoreMain() {
      const store = this.storeList.find(s => s.id === this.fundStoreId)
      return !!store && String(store.isMain) === '1'
    }
  },
  created() {
    this.loadStores()
    this.loadHistory()
  },
  methods: {
    // 金额格式化（模板用，代理模块级函数）
    fmtMoney(val) {
      return fmtMoney(val)
    },
    // ===== 区块1：允许门店收款（门店级开关；门店列表行 allowPay 回显，PUT /stores/{id} 保存） =====
    // 门店下拉（列表接口全量取，pageSize=100）
    loadStores() {
      const that = this
      getAction(STORE_PREFIX, { page: 1, pageSize: 100 }).then(res => {
        if (res.code === 200) {
          that.storeList = res.data.rows || []
          if (that.storeList.length) {
            that.fundStoreId = that.storeList[0].id
            that.syncFundSwitch()
            if (that.isFundStoreMain) {
              that.loadCommission()
            }
          }
        } else {
          that.$message.warning(res.message)
        }
      })
    },
    onFundStoreChange() {
      this.syncFundSwitch()
      if (this.isFundStoreMain) {
        this.loadCommission()
      }
    },
    // 选中门店的收款开关回显（chainList 行 allowPay：'1'=开启；未返回按关闭）
    syncFundSwitch() {
      const store = this.storeList.find(s => s.id === this.fundStoreId)
      this.fundAllowPaySwitch = !!store && String(store.allowPay) === '1'
    },
    handleSaveFund() {
      const that = this
      if (!this.fundStoreId) {
        this.$message.warning('请选择门店')
        return
      }
      if (this.isFundStoreMain) {
        this.$message.warning('总店无需配置门店收款')
        return
      }
      this.fundSaving = true
      putAction(`${STORE_PREFIX}/${this.fundStoreId}`, {
        allowPay: this.fundAllowPaySwitch ? '1' : '0'
      }).then(res => {
        if (res.code === 200) {
          that.$message.success('保存成功')
          // 本地行同步，避免重复拉列表
          const store = that.storeList.find(s => s.id === that.fundStoreId)
          if (store) {
            store.allowPay = that.fundAllowPaySwitch ? '1' : '0'
          }
        } else {
          that.$message.warning(res.message)
        }
      }).catch(() => {}).finally(() => {
        that.fundSaving = false
      })
    },
    // ===== 服务费率设置（仅总店；GET/PUT store-setting/commission） =====
    loadCommission() {
      const that = this
      getAction(`${SETTING_PREFIX}/commission`, { storeId: this.fundStoreId }).then(res => {
        if (res.code === 200) {
          that.commissionForm = Object.assign({}, COMMISSION_DEFAULTS, res.data || {})
        }
      })
    },
    // 商家获得% 只读自动 = 100 - 平台抽佣%（云贝三段式联动）
    getStoreProportion(key) {
      const platform = Number(this.commissionForm[key + 'PlatformProportion']) || 0
      const store = 100 - platform
      return store > 0 ? store : 0
    },
    handleSaveCommission() {
      const that = this
      if (!this.fundStoreId || !this.isFundStoreMain) {
        return
      }
      const body = Object.assign({}, this.commissionForm)
      if (body.rule === '2' && body.type === '1') {
        for (let i = 0; i < COMMISSION_ITEMS.length; i++) {
          const key = COMMISSION_ITEMS[i].key
          const val = Number(body[key + 'PlatformProportion'])
          if (isNaN(val) || val < 0 || val > 100) {
            that.$message.warning(COMMISSION_ITEMS[i].label + '抽佣比例应在 0-100 之间')
            return
          }
          // 商家获得% 自动回填随组保存
          body[key + 'StoreProportion'] = that.getStoreProportion(key)
        }
      }
      this.commissionSaving = true
      putAction(`${SETTING_PREFIX}/commission?storeId=${this.fundStoreId}`, body).then(res => {
        if (res.code === 200) {
          that.$message.success('保存成功')
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.commissionSaving = false
      })
    },
    // ===== 对账计提（预览，不再触发确认结算） =====
    cycleRange() {
      const m = this.settleMonth || moment()
      return {
        cycleStart: m.clone().startOf('month').format('YYYY-MM-DD'),
        cycleEnd: m.clone().endOf('month').format('YYYY-MM-DD')
      }
    },
    handlePreview() {
      const that = this
      this.previewLoading = true
      getAction(`${SETTLE_PREFIX}/preview`, this.cycleRange()).then(res => {
        if (res.code === 200) {
          that.previewList = res.data || []
        } else {
          that.$message.warning(res.message)
        }
        that.previewLoading = false
      }).catch(() => {
        that.previewLoading = false
      })
    },
    // ===== 结算历史 =====
    loadHistory() {
      const that = this
      this.historyLoading = true
      const month = (this.historyMonth || moment()).format('YYYY-MM')
      getAction(`${SETTLE_PREFIX}/history`, { month: month }).then(res => {
        if (res.code === 200) {
          that.historyList = res.data || []
        } else {
          that.$message.warning(res.message)
        }
        that.historyLoading = false
      }).catch(() => {
        that.historyLoading = false
      })
    },
    // ===== 提现审批 =====
    onTabChange(key) {
      // 提现审批 Tab 懒加载（首次切入拉一次，后续由审批/标记操作触发刷新）
      if (key === 'withdraw' && !this.withdrawLoaded) {
        this.withdrawLoaded = true
        this.loadWithdrawList()
      }
    },
    loadWithdrawList() {
      const that = this
      this.withdrawLoading = true
      const params = {
        page: this.withdrawPagination.current,
        pageSize: this.withdrawPagination.pageSize
      }
      if (this.withdrawQuery.status) {
        params.status = this.withdrawQuery.status
      }
      getAction(`${WITHDRAW_PREFIX}/list`, params).then(res => {
        if (res.code === 200) {
          that.withdrawList = (res.data && res.data.rows) || []
          that.withdrawPagination.total = (res.data && res.data.total) || 0
        } else {
          that.$message.warning(res.message)
        }
        that.withdrawLoading = false
      }).catch(() => {
        that.withdrawLoading = false
      })
    },
    onWithdrawSearch() {
      this.withdrawPagination.current = 1
      this.loadWithdrawList()
    },
    onWithdrawPageChange(pagination) {
      this.withdrawPagination.current = pagination.current
      this.withdrawPagination.pageSize = pagination.pageSize
      this.loadWithdrawList()
    },
    // 通过：二次确认（生成付款单草稿，实际支付走主工程付款单流程）
    handleAuditPass(record) {
      const that = this
      this.$confirm({
        title: '审批确认',
        content: '通过后将生成付款单草稿，实际支付请到 财务管理-付款单 执行，确认通过？',
        onOk() {
          return postAction(`${WITHDRAW_PREFIX}/${record.id}/audit`, { pass: true }).then(res => {
            if (res.code === 200) {
              that.$message.success('已通过')
              that.loadWithdrawList()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // 驳回：弹窗填原因（必填）
    handleAuditReject(record) {
      this.rejectRecord = record
      this.rejectReason = ''
      this.rejectVisible = true
    },
    handleRejectSubmit() {
      const that = this
      if (!this.rejectReason || !this.rejectReason.trim()) {
        this.$message.warning('请填写驳回原因')
        return
      }
      this.auditLoading = true
      postAction(`${WITHDRAW_PREFIX}/${this.rejectRecord.id}/audit`, {
        pass: false,
        rejectReason: this.rejectReason.trim()
      }).then(res => {
        if (res.code === 200) {
          that.$message.success('已驳回')
          that.rejectVisible = false
          that.loadWithdrawList()
        } else {
          that.$message.warning(res.message)
        }
      }).finally(() => {
        that.auditLoading = false
      })
    },
    // 标记已支付（仅已通过单，财务完成付款单支付后对账闭环）
    handleMarkPaid(record) {
      const that = this
      this.$confirm({
        title: '标记已支付',
        content: '请确认财务已在付款单中完成该笔支付，确认标记为已支付？',
        onOk() {
          return postAction(`${WITHDRAW_PREFIX}/${record.id}/mark-paid`).then(res => {
            if (res.code === 200) {
              that.$message.success('已标记为已支付')
              that.loadWithdrawList()
            } else {
              that.$message.warning(res.message)
            }
          })
        }
      })
    },
    // 单据号复制（照一期 StoreInfo 模式）
    copyText(text) {
      if (!text) {
        return
      }
      const textarea = document.createElement('textarea')
      textarea.value = String(text)
      document.body.appendChild(textarea)
      textarea.select()
      document.execCommand('copy')
      document.body.removeChild(textarea)
      this.$message.success('复制成功')
    }
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
.section-title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 10px;
  border-left: 3px solid #1890ff;
  margin: 8px 0 12px;
}
.field-tip {
  color: #999;
  font-size: 12px;
  line-height: 16px;
  margin-top: 8px;
}
.fund-switch-tip {
  color: #999;
  font-size: 12px;
  margin-left: 4px;
}
.settle-tip {
  margin-bottom: 10px;
}
.bill-no {
  font-family: monospace;
}
.setting-form {
  max-width: 760px;
}
.prop-sep {
  margin: 0 8px;
}
.form-footer {
  text-align: center;
  margin-top: 16px;
  border-top: 1px solid #e8e8e8;
  padding-top: 16px;
  max-width: 760px;
}
.amount-red {
  color: #f5222d;
  font-weight: 600;
}
</style>
